export const css = {
    root: '_3aQQ4BwB',
    content: 'a5AoNHZY',
    bottom: 'ZuqF2DQJ',
    top: '_3Z-DBuNU',
    left: '_3cuN_VYr',
    right: '_2bGkmOXa',
    ' _key': 'apic-theme/apic/dojo/tooltip'
};
export default css;
